
export const headerHeight = '50px';
export const footerHeight = '50px';


export default {
  headerHeight,
  footerHeight,
};
